import { render, staticRenderFns } from "./GlossaryDialog.vue?vue&type=template&id=13fefc2c&"
import script from "./GlossaryDialog.vue?vue&type=script&lang=js&"
export * from "./GlossaryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports